
//Login Action
export const GET_LOGIN = "GET_LOGIN";
export const GET_LOGIN_REQUESTED = "GET_LOGIN_REQUESTED";
export const GET_LOGIN_SUCCESS = "GET_LOGIN_SUCCESS";
export const GET_LOGIN_FAILED = "GET_LOGIN_FAILED";

//Otp Action
export const GET_OTP = "GET_OTP";
export const GET_OTP_REQUESTED = "GET_OTP_REQUESTED";
export const GET_OTP_SUCCESS = "GET_OTP_SUCCESS";
export const GET_OTP_FAILED = "GET_OTP_FAILED";

//FAQ Action
export const GET_FAQ = "GET_FAQ";
export const GET_FAQ_REQUESTED = "GET_FAQ_REQUESTED";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_FAILED = "GET_FAQ_FAILED";

//Create FAQ Action
export const GET_ADDFAQ = "GET_ADDFAQ";
export const GET_ADDFAQ_REQUESTED = "GET_ADDFAQ_REQUESTED";
export const GET_ADDFAQ_SUCCESS = "GET_ADDFAQ_SUCCESS";
export const GET_ADDFAQ_FAILED = "GET_ADDFAQ_FAILED";

//Update FAQ Action
export const GET_UPDATEFAQ = "GET_UPDATEFAQ";
export const GET_UPDATEFAQ_REQUESTED = "GET_UPDATEFAQ_REQUESTED";
export const GET_UPDATEFAQ_SUCCESS = "GET_UPDATEFAQ_SUCCESS";
export const GET_UPDATEFAQ_FAILED = "GET_UPDATEFAQ_FAILED";

//Delete FAQ Action
export const GET_DELETEFAQ = "GET_DELETEFAQ";
export const GET_DELETEFAQ_REQUESTED = "GET_DELETEFAQ_REQUESTED";
export const GET_DELETEFAQ_SUCCESS = "GET_DELETEFAQ_SUCCESS";
export const GET_DELETEFAQ_FAILED = "GET_DELETEFAQ_FAILED";


//FAQ Section Action
export const GET_FAQ_SECTION = "GET_FAQ_SECTION";
export const GET_FAQ_SECTION_REQUESTED = "GET_FAQ_SECTION_REQUESTED";
export const GET_FAQ_SECTION_SUCCESS = "GET_FAQ_SECTION_SUCCESS";
export const GET_FAQ_SECTION_FAILED = "GET_FAQ_SECTION_FAILED";

//Registration Action
export const GET_REGISTRATION = "GET_REGISTRATION";
export const GET_REGISTRATION_REQUESTED = "GET_REGISTRATION_REQUESTED";
export const GET_REGISTRATION_SUCCESS = "GET_REGISTRATION_SUCCESS";
export const GET_REGISTRATION_FAILED = "GET_REGISTRATION_FAILED";


//Logout Action
export const GET_LOGOUT = "GET_LOGOUT";
export const GET_LOGOUT_REQUESTED = "GET_LOGOUT_REQUESTED";
export const GET_LOGOUT_SUCCESS = "GET_LOGOUT_SUCCESS";
export const GET_LOGOUT_FAILURE = "GET_LOGOUT_FAILURE";

//Trip Action
export const GET_TRIP = "GET_TRIP";
export const GET_TRIP_REQUESTED = "GET_TRIP_REQUESTED";
export const GET_TRIP_SUCCESS = "ET_TRIP_SUCCESS";
export const GET_TRIP_FAILED = "GET_TRIP_FAILED";

//ShareTrip Action
export const GET_SHARE_TRIP = "GET_SHARE_TRIP";
export const GET_SHARE_TRIP_REQUESTED = "GET_SHARE_TRIP_REQUESTED";
export const GET_SHARE_TRIP_SUCCESS = "GET_SHARE_TRIP_SUCCESS";
export const GET_SHARE_TRIP_FAILED = "GET_SHARE_TRIP_FAILED";

//Google Map AutoComplete
export const GET_GOOGLE_MAP_AUTOCOMPLETE = "GET_GOOGLE_MAP_AUTOCOMPLETE";
export const GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED ="GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED";
export const GET_GOOGLE_MAP_AUTOCOMPLETE_SUCCESS = "GET_GOOGLE_MAP_AUTOCOMPLETE_SUCCESS";
export const GET_GOOGLE_MAP_AUTOCOMPLETE_FAILED = "GET_GOOGLE_MAP_AUTOCOMPLETE_FAILED"

//Google Map NearBySearch
export const GET_GOOGLE_NEARBY_SEARCH = "GET_GOOGLE_NEARBY_SEARCH ";
export const GET_GOOGLE_NEARBY_SEARCH_REQUESTED ="GET_GOOGLE_NEARBY_SEARCH_REQUESTED";
export const GET_GOOGLE_NEARBY_SEARCH_SUCCESS = "GET_GOOGLE_NEARBY_SEARCH_SUCCESS";
export const GET_GOOGLE_NEARBY_SEARCH_FAILED = "GET_GOOGLE_NEARBY_SEARCH_FAILED"

//Google Map Place details
export const GET_GOOGLE_MAP_PLACE_DETAILS = "GET_GOOGLE_MAP_PLACE_DETAILS";
export const GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED = "GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED";
export const GET_GOOGLE_MAP_PLACE_DETAILS_SUCCESS = "GET_GOOGLE_MAP_PLACE_DETAILS_SUCCESS";
export const GET_GOOGLE_MAP_PLACE_DETAILS_PICKUP_SUCCESS = "GET_GOOGLE_MAP_PLACE_DETAILS_PICKUP_SUCCESS";
export const GET_GOOGLE_MAP_PLACE_DETAILS_DROP_SUCCESS = "GET_GOOGLE_MAP_PLACE_DETAILS_DROP_SUCCESS";
export const GET_GOOGLE_MAP_PLACE_DETAILS_FAILED = "GET_GOOGLE_MAP_PLACE_DETAILS_FAILED"

//Google Map Direction details
export const GET_GOOGLE_MAP_DIRECTION_DETAILS = "GET_GOOGLE_MAP_DIRECTION_DETAILS";
export const GET_GOOGLE_MAP_DIRECTION_REQUESTED = "GET_GOOGLE_MAP_DIRECTION_REQUESTED";
export const GET_GOOGLE_MAP_DIRECTION_SUCCESS = "GET_GOOGLE_MAP_DIRECTION_SUCCESS";
export const GET_GOOGLE_MAP_DIRECTION_FAILED = "GET_GOOGLE_MAP_DIRECTION_FAILED";

//Google Map Geocode details
export const GET_GEOCODE = "GET_GEOCODE";
export const GET_GEOCODE_REQUESTED = "GET_GEOCODE_REQUESTED";
export const GET_GEOCODE_SUCCESS = "GET_GEOCODE_SUCCESS";
export const GET_GEOCODE_FAILED = "GET_GEOCODE_FAILED";

//Rate Calculation
export const GET_RATE_CALCULATION = "GET_RATE_CALCULATION";
export const GET_RATE_CALCULATION_REQUESTED = "GET_RATE_CALCULATION_REQUESTED";
export const GET_RATE_CALCULATION_SUCCESS = "GET_RATE_CALCULATION_SUCCESS";
export const GET_RATE_CALCULATION_FAILED = "GET_RATE_CALCULATION_FAILED";

//Profile
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_REQUESTED = "GET_PROFILE_REQUESTED";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED";

//Update Profile
export const GET_UPDATEPROFILE = "GET_UPDATEPROFILE";
export const GET_UPDATEPROFILE_REQUESTED = "GET_UPDATEPROFILE_REQUESTED";
export const GET_UPDATEPROFILE_SUCCESS = "GET_UPDATEPROFILE_SUCCESS";
export const GET_UPDATEPROFILE_FAILED = "GET_UPDATEPROFILE_FAILED";

//Verify Profile
export const GET_VERIFY_PROFILE = "GET_VERIFY_PROFILE";
export const GET_VERIFY_PROFILE_REQUESTED = "GET-VERIFY_PROFILE_REQUESTED";
export const GET_VERIFY_PROFILE_SUCCESS = "GET_VERIFY_PROFILE_SUCCESS";
export const GET_VERIFY_PROFILE_FAILED = "GET_VERIFY_PROFILE_FAILED";

//Trip Checkout
export const GET_TRIP_CHECKOUT = "GET_TRIP_CHECKOUT";
export const GET_TRIP_CHECKOUT_REQUESTED = "GET_TRIP_CHECKOUT_REQUESTED";
export const GET_TRIP_CHECKOUT_SUCCESS = "GET_TRIP_CHECKOUT_SUCCESS";
export const GET_TRIP_CHECKOUT_FAILED = "GET_TRIP_CHECKOUT_FAILED";

//Verify Payment
export const GET_PAYMENT_VERIFY = "GET_PAYMENT_VERIFY";
export const GET_PAYMENT_VERIFY_REQUESTED = "GET_PAYMENT_VERIFY_REQUESTED";
export const GET_PAYMENT_VERIFY_SUCCESS = "GET_PAYMENT_VERIFY_SUCCESS";
export const GET_PAYMENT_VERIFY_FAILED = "GET_PAYMENT_VERIFY_FAILED";

//Hash Payment
export const GET_PAYMENT_HASHED = "GET_PAYMENT_HASHED";
export const GET_PAYMENT_HASHED_REQUESTED ="GET_PAYMENT_HASHED_REQUESTED";
export const GET_PAYMENT_HASHED_SUCCESS = "GET_PAYMENT_HASHED_SUCCESS";
export const GET_PAYMENT_HASHED_FAILED = "GET_PAYMENT_HASHED_FAILED";

//PayU 
export const GET_PAYU = "GET_PAYU";
export const GET_PAYU_REQUESTED = "GET_PAYU_REQUESTED";
export const GET_PAYU_SUCCESS = "GET_PAYU_SUCCESS";
export const GET_PAYU_FAILED = "GET_PAYU_FAILED";

//PayU 
export const GET_PAYU_RESPONSE = "GET_PAYU_RESPONSE";
export const GET_PAYU_RESPONSE_REQUESTED = "GET_PAYU_RESPONSE_REQUESTED";
export const GET_PAYU_RESPONSE_SUCCESS = "GET_PAYU_RESPONSE_SUCCESS";
export const GET_PAYU_RESPONSE_FAILED = "GET_PAYU_RESPONSE_FAILED";

//Airport 
export const GET_TRIP_SLAB = "GET_TRIP_SLAB";
export const GET_TRIP_SLAB_REQUESTED = "GET_TRIP_SLAB_REQUESTED";
export const GET_TRIP_SLAB_SUCCESS = "GET_TRIP_SLAB_SUCCESS";
export const GET_TRIP_SLAB_FAILED = "GET_TRIP_SLAB_FAILED";

//CancelTrip
export const GET_CANCEL_TRIP = "GET_CANCEL_TRIP";
export const GET_CANCEL_TRIP_REQUESTED = "GET_CANCEL_TRIP_REQUESTED";
export const GET_CANCEL_TRIP_SUCCESS ="GET_CANCEL_TRIP_SUCCESS";
export const GET_CANCEL_TRIP_FAILED ="GET_CANCEL_TRIP_FAILED";

//CancelReason
export const GET_CANCEL_REASON = "GET_CANCEL_REASON";
export const GET_CANCEL_REASON_REQUESTED = "GET_CANCEL_REASON_REQUESTED";
export const GET_CANCEL_REASON_SUCCESS="GET_CANCEL_REASON_SUCCESS";
export const GET_CANCEL_REASON_FAILED="GET_CANCEL_REASON_FAILED";

//TripCompletion
export const GET_TRIP_COMPLETION = "GET_TRIP_COMPLETION";
export const GET_TRIP_COMPLETION_REQUESTED = "GET_TRIP_COMPLETION_REQUESTED";
export const GET_TRIP_COMPLETION_SUCCESS = "GET_TRIP_COMPLETION_SUCCESS";
export const GET_TRIP_COMPLETION_FAILED = "GET_TRIP_COMPLETION_FAILED";

//RefundPrices
export const GET_REFUND_PRICE = "GET_REFUND_PRICE";
export const GET_REFUND_PRICE_REQUESTED = "GET_REFUND_PRICE_REQUESTED";
export const GET_REFUND_PRICE_SUCCESS = "GET_REFUND_PRICE_SUCCESS";
export const GET_REFUND_PRICE_FAILED = "GET_REFUND_PRICE_FAILED";

//Rental Slab 
export const GET_RENATAL_SLAB = "GET_RENATAL_SLAB";
export const GET_RENATAL_SLAB_REQUESTED = "GET_RENATAL_SLAB_REQUESTED";
export const GET_RENATAL_SLAB_SUCCESS = "GET_RENATAL_SLAB_SUCCESS";
export const GET_RENATAL_SLAB_FAILED = "GET_RENATAL_SLAB_FAILED";
 
//Loader
export const LOADER = {
    LOADER_TRIGGER: "loader-trigger",
    LOADER_SHOW: "loader-show"
};

//cashfree 
export const GET_CASHFREE = "GET_CASHFREE";
export const GET_CASHFREE_REQUESTED = "GET_CASHFREE_REQUESTED";
export const GET_CASHFREE_SUCCESS = "GET_CASHFREE_SUCCESS";
export const GET_CASHFREE_FAILED = "GET_CASHFREE_FAILED";

//Verify Cashfree
export const GET_CASHFREE_VERIFY = "GET_CASHFREE_VERIFY";
export const GET_CASHFREE_VERIFY_REQUESTED = "GET_CASHFREE_VERIFY_REQUESTED";
export const GET_CASHFREE_VERIFY_SUCCESS = "GET_CASHFREE_VERIFY_SUCCESS";
export const GET_CASHFREE_VERIFY_FAILED = "GET_CASHFREE_VERIFY_FAILED";

// Clear reducer 
export const GET_CLEAR_AUTOCOMPLETE = "GET_CLEAR_AUTOCOMPLETE";
export const GET_CLEAR_RATE_CALCULATION = "GET_CLEAR_RATE_CALCULATION";
export const GET_CLEAR_DIRECTION = "GET_CLEAR_DIRECTION";

// Payment Method
export const GET_PAYMENT_METHOD = "GET_PAYMENT_METHOD";
export const GET_PAYMENT_METHOD_REQUESTED = "GET_PAYMENT_METHOD_REQUESTED";
export const GET_PAYMENT_METHOD_SUCCESS = "GET_PAYMENT_METHOD_SUCCESS";
export const GET_PAYMENT_METHOD_FAILED = "GET_PAYMENT_METHOD_FAILED";

//Coupon List
export const GET_COUPON_LIST = "GET_COUPON_LIST";
export const GET_COUPON_LIST_REQUESTED = "GET_COUPON_LIST_REQUESTED";
export const GET_COUPON_LIST_SUCCESS ="GET_COUPON_LIST_SUCCESS";
export const GET_COUPON_LIST_FAILED ="GET_COUPON_LIST_FAILED";

//Apply Coupon List
export const GET_APPLY_COUPON = "GET_APPLY_COUPON";
export const GET_APPLY_COUPON_REQUESTED = "GET_APPLY_COUPON_REQUESTED";
export const GET_APPLY_COUPON_SUCCESS ="GET_APPLY_COUPON_SUCCESS";
export const GET_APPLY_COUPON_FAILED ="GET_APPLY_COUPON_FAILED";
export const GET_APPLY_COUPON_CLEAR = "GET_APPLY_COUPON_CLEAR";

//Apply Coupon Rental
export const GET_APPLY_COUPON_RENTAL = "GET_APPLY_COUPON_RENTAL";
export const GET_APPLY_COUPON_RENTAL_REQUESTED = "GET_APPLY_COUPON_RENTAL_REQUESTED";
export const GET_APPLY_COUPON_RENTAL_SUCCESS ="GET_APPLY_COUPON_RENTAL_SUCCESS";
export const GET_APPLY_COUPON_RENTAL_FAILED ="GET_APPLY_COUPON_RENTAL_FAILED";
export const GET_APPLY_COUPON_RENTAL_CLEAR = "GET_APPLY_COUPON_RENTAL_CLEAR";

//Location Check
export const GET_LOCATIONCHECK = "GET_LOCATIONCHECK";
export const GET_LOCATIONCHECK_REQUESTED = "GET_LOCATIONCHECK_REQUESTED";
export const GET_LOCATIONCHECK_SUCCESS = "GET_LOCATIONCHECK_SUCCESS";
export const GET_LOCATIONCHECK_FAILED = "GET_LOCATIONCHECK_FAILED";
export const GET_LOCATIONCHECK_CLEAR = "GET_LOCATIONCHECK_CLEAR";